import Derivative from './derivative';
import IModel from './interfaces/model.d';

export default class Results {
  public bodystyles: string[] = [];

  public models: IModel[] = [];

  public items: Derivative[] = [];
}
